
export class ProfileSection {
  public sectionKey: string = "";
  public displayName: string = "";
  public iconKey: string = "";
}

export class UserProfileConfig {
  public profileSections: ProfileSection[] = [];
}